import { KibsiClient } from './base';
export class EventKibsiClient extends KibsiClient {
    constructor(params) {
        super(params, 'event');
    }
    listEvents(paginationRequest, requestConfig) {
        const { continuationToken, pageSize, sort, criteria = {} } = paginationRequest || {};
        const { active, deploymentId, applicationId, siteId, itemType, itemTypes, startDateTime, endDateTime, dataCollection, startState, } = criteria;
        const request = requestConfig ? { ...requestConfig } : {};
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        request.params = {
            ...requestConfig?.params,
            continuationToken,
            pageSize,
            sort,
            deploymentId,
            active,
            applicationId,
            siteId,
            itemType,
            itemTypes: itemTypes?.join(','),
            startDateTime,
            endDateTime,
            dataCollection,
        };
        for (const [key, value] of Object.entries(startState ?? {})) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            request.params[`start.${key}`] = value;
        }
        return this.get('/events', request);
    }
    getEvent(deploymentId, eventId, requestConfig) {
        return this.get(`events/${deploymentId}/${eventId}`, requestConfig);
    }
    getEventMediaMetadata(deploymentId, eventId, requestConfig) {
        return this.get(`events/${deploymentId}/${eventId}/media`, requestConfig);
    }
    getMediaDownload(mediaId, requestConfig) {
        return this.get(`media/${mediaId}/download`, { ...requestConfig, responseType: 'blob' });
    }
    setEventFlagged(deploymentId, eventId, flagged, requestConfig) {
        return this.put(`events/${deploymentId}/${eventId}/flag`, { flagged }, requestConfig);
    }
    getEventCounts(deploymentId, eventId, requestConfig) {
        return this.get(`events/${deploymentId}/${eventId}/counts`, requestConfig);
    }
}
//# sourceMappingURL=event.js.map